import type { RobotModelForLiveMap } from '../../liveMap/liveMapActions.types';
import type { LocateSettings, LocateSettingsFields, PausedStateFields } from '../types/RobotCleaningControl.types';
import { LocateStatus } from './constants';
import { DeviceStateEnum } from 'app/cross-cutting-concerns/communication/interfaces/pra-api-graphql';

// B50 reports pause through Device.state.paused; CV50 only through Device.state.deviceState.
export const resolveIsPaused = (model: RobotModelForLiveMap, state?: PausedStateFields | null): boolean | undefined => {
  if (model === 'CV50') {
    return state?.deviceState == null ? undefined : state.deviceState === DeviceStateEnum.Pause;
  }

  return state?.paused ?? undefined;
};

// A subscription event can carry only some of the settings, so a missing field stays undefined and
// must not overwrite the known value.
export const resolveLocateSettings = (settings?: LocateSettingsFields | null): LocateSettings => ({
  beep: settings?.beep == null ? undefined : settings.beep === LocateStatus.On,
  blink: settings?.blink == null ? undefined : settings.blink === LocateStatus.On,
});
